module.exports = __webpack_public_path__ + "img/watatsuki no toyohime_sc2.491436f6.png";